import { render, staticRenderFns } from "./VoucherAddressLink.vue?vue&type=template&id=4bd4ad14&"
import script from "./VoucherAddressLink.vue?vue&type=script&lang=js&"
export * from "./VoucherAddressLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd4ad14')) {
      api.createRecord('4bd4ad14', component.options)
    } else {
      api.reload('4bd4ad14', component.options)
    }
    module.hot.accept("./VoucherAddressLink.vue?vue&type=template&id=4bd4ad14&", function () {
      api.rerender('4bd4ad14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/VoucherAddressLink.vue"
export default component.exports